import type { DelayedQuote } from '@benzinga/quotes-manager';
import { REALTIME_QUOTE_STALE_BUFFER_MS } from './realtime-quote';

const toMillis = (date: string | null | undefined): number | null => {
  if (!date) return null;
  const ms = Date.parse(date);
  return Number.isFinite(ms) ? ms : null;
};

const staleBeforeMs = (quote: DelayedQuote, nowMs: number | null): number | null => {
  const previousClose = toMillis(quote.previousCloseDate);
  const close = toMillis(quote.closeDate);
  const passedClose = close != null && nowMs != null && close <= nowMs ? close : null;
  const cutoff = Math.max(previousClose ?? 0, passedClose ?? 0);
  return cutoff > 0 ? cutoff - REALTIME_QUOTE_STALE_BUFFER_MS : null;
};

export const withoutStaleDelayedTrades = <T extends DelayedQuote | null | undefined>(quote: T, nowMs: number | null): T => {
  if (!quote) return quote;
  const cutoff = staleBeforeMs(quote, nowMs);
  if (cutoff == null) return quote;

  const lastTradeStale = typeof quote.lastTradeTime === 'number' && quote.lastTradeTime < cutoff;
  const ethStale = typeof quote.ethTime === 'number' && quote.ethTime < cutoff;
  if (!lastTradeStale && !ethStale) return quote;

  const missing = undefined as unknown as number;
  const next = { ...quote };
  if (lastTradeStale) {
    const closeMs = toMillis(quote.closeDate);
    const hasClose = typeof quote.close === 'number' && closeMs != null;
    next.lastTradePrice = hasClose ? quote.close : missing;
    next.lastTradeTime = hasClose ? closeMs : missing;
  }
  if (ethStale) {
    next.ethPrice = missing;
    next.ethTime = missing;
  }
  return next;
};
